import React from 'react'
import { CircularProgress, Typography, Box } from '@mui/material'

const CircularProgressScreen = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#0f172a', 
        color: '#fff',
      }}
    >
      <CircularProgress color="inherit" />
      {/* <Typography variant="h6" sx={{ mt: 2 }}>
        Loading...
      </Typography> */}
    </Box>
  )
}

export default CircularProgressScreen
